import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the state type
interface LanguageState {
  language: string;
}

// Initial state
const initialState: LanguageState = {
    language: 'english',
};

// Slice for language state
const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload;
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
